import { ALERT_MAX } from "@/config/alert";
import { PREFIX_MAX } from "@/config/series";
import { TimeRange } from "@/types/time-range";
import { Layout } from "@/types/layout";
import { generateProcessedStatsState } from "@/utils/series";
import { Stats, StatType } from "@/types/stats";
import { Features, Settings } from "@/types/settings";
import { ProcessedStatsState } from "@/types/processed-stats";
import { RootState } from "@/types/root-state";

export class State implements RootState {
  token = "";
  activeCacheID = 0;
  activePrefixID = 0;
  mobileMenuOpen = false;
  timeRange = TimeRange.LAST_DAY;
  layout = Layout.HAS_SIDEBAR;
  promoBannerDismissed = true;
}

export class StatsInitialState implements Stats {
  [propName: string]: number;
  limit_maxbytes = 0;
  bytes = 0;
  curr_connections = 0;
  curr_items = 0;
  evictions = 0;
  total_connections = 0;
  get_hits = 0;
  get_misses = 0;
  delete_hits = 0;
  delete_misses = 0;
  incr_hits = 0;
  incr_misses = 0;
  decr_hits = 0;
  decr_misses = 0;
  cas_hits = 0;
  cas_misses = 0;
  touch_hits = 0;
  touch_misses = 0;
  cmd_flush = 0;
  cmd_set = 0;
}

export class ProcessedStatsInitialState implements ProcessedStatsState {
  // Aggregate series
  processedStats = generateProcessedStatsState(StatType.PROCESSED);
  processedStatsStatus = {};
  processedStatsLastFetched = {};

  // Per server series
  perServerProcessedStats = generateProcessedStatsState(StatType.PROCESSED);
  perServerProcessedStatsStatus = {};
  perServerProcessedStatsLastFetched = {};
}

export class SettingsItemInitialState implements Settings {
  cache_type = "";
  can_manage_credentials = false;
  can_update_capabilities = false;
  can_switch = false;
  cluster_name = "";
  credentials = [];
  enabled = false;
  id = 0;
  name = "";
  label = "";
  provider = "";
  servers = [];
  plan = 0;
}

export class FeaturesItemInitialState implements Features {
  [propName: string]: number;
  "debug-mode" = 0;
  "shadow-cache" = 0;
  version = 0;
  "alert-config" = -1;
  "alert-limit" = 0;
  "collect-granularity" = 0;
  "persist-key-stats" = 0;
  "persist-slab-stats" = 0;
  "prefix-limit" = 0;
  "persist-granularity" = 0;
  "recent-log-length" = 0;
  "consulting-offer" = 0;
  "alert-max" = ALERT_MAX;
  "prefix-max" = PREFIX_MAX;
}
